<template>
	<div ref="wrapperDropdown" class="dropdown_query lm-dropdown-wrap">
		<div :class="{ active: statusOpenForm }">
			<div class="lm-dropdown" :class="{ open: statusOpenForm }">
				<i @click="focusInput" v-if="!statusLoader && arrayValues.length" ref="icon" class="lm-dropdown-icon" />

				<div v-if="statusLoader" class="spin-position spin-lg-container">
					<i class="spin spin-lg" data-test-id="load_animation" />
				</div>

				<label class="w-100">
					<input
						:placeholder="
							this.c_ctrlParams.customPlaceholder ? this.c_ctrlParams.customPlaceholder : ''
						"
						:data-test-id="c_test_attrs['test-dbcolname']"
						@focus="focusInput"
						ref="search"
						class="form-control d-input"
						v-model="inputValue"
						type="text"
					/>
				</label>
			</div>

			<div class="lm-dropdown-menu" ref="dropdown">
				<ul :style="{ 'max-height': maxHeight }" ref="dropdownElement">
					<li style="display: flex" v-for="(el, idx) in arrayValues" :key="idx">
						<!--				если не задан формат вывода в админке, то будет выведиться так
												Шаблон express_code || nsi_id - name - railway_id
						-->
						<span class="lm-dropdown-menu--item" @click="select(el.node)">
								{{ renderResult(el.node, true) }}
						</span>
					</li>

					<template v-if="inputValue.length && !statusLoader">
						<li v-if="!arrayValues.length && inputValue.length !== 0" class="no-options">
							<span class="lm-dropdown-menu--item">К сожалению, ничего не найдено.</span>
						</li>
					</template>
				</ul>
			</div>
		</div>

		<div class="help-block"></div>
		<div class="ctrl-extraDescr" v-if="c_ctrlParams.extraDescr" v-html="c_ctrlParams.extraDescr"></div>
	</div>
</template>

<script>
import ctrlMixins from './_mixins.js';
import urlUtil from '@uarmRoot/src/util-url';
import axios from 'axios';
import { ctrlParamsForAll } from './_common-stuff.ts';

export default {
	name: 'ctrl_dropdown_suggester',
	mixins: [ctrlMixins], // c_value, c_ctrlParams, c_srv_options, пропсы view_type, field_meta и так далее
	meta: {
		// это наши данные, т.е. вуй при объявлении компонента их не использует
		title: 'Подсказчик',
		params: {
			selectSuggesterName: {
				name: 'Индекс запроса',
				editType: 'input',
				default: '',
			},
			indexFields: {
				name: 'Поля, которые попадут в контрол',
				tip: 'Поля дожны быть перечислены через пробел в том порядке, в котором они должны выводиться в контрол при запросе',
				editType: 'input',
				default: '',
			},
			delimiter: {
				name: 'Разделитель между значениями',
				tip: 'Символы, вставляемые между значениями, которые попадут на фронт. По умолчанию - пробел.',
				editType: 'input',
				default: ' ',
			},
			customPlaceholder: {
				name: 'Placeholder',
				editType: 'input',
				default: '',
			},
			...ctrlParamsForAll,
		},
	},
	props: {
		maxHeight: {
			type: String,
			default: '200px',
		},
		value: {
			default() {
				// параметр контрола defaultValue имеет более высокий приоритет
				// и применяется на более высоком уровне, тут речь только о ситуации когда ни значения ни defaultValue нет
				return this.view_type === 'filter' ? '' : null;
			},
		},
	},
	data: () => ({
		arrayValues: [],
		inputValue: '',
		baseUrl: '',
		baseUrlArm: '',
		constQuery: '&lang=ru',
		timeout: null,
		bodyElem: null,
		selectSuggesterName: '',
		indexFields: '',
		delimiter: ' ',

		statusOpenForm: false, // открытие формы
		statusLoader: false, // loader
		statusSendQuery: true, // когда выбрали что то из списк, чтобы этот выбор на отправился на сервер
	}),
	watch: {
		inputValue() {
			if (!this.inputValue.length) {
				this.arrayValues.length = 0;
			}
			if (this.inputValue.length && this.statusSendQuery) {
				clearTimeout(this.timeout);
				this.timeout = setTimeout(() => {
					this.sendQuery();
				}, 1000);
			} else {
				clearTimeout(this.timeout);
			}
			this.statusSendQuery = true;
		},
	},
	mounted() {
		this.c_ctrlParams.indexFields !== '' ? this.indexFields = this.c_ctrlParams.indexFields : this.indexFields = '';
		this.c_ctrlParams.delimiter !== '' ? this.delimiter = this.c_ctrlParams.delimiter : this.indexFields = '';
		this.bodyElem = document.querySelector('body');
		if (this.value) {
			this.sendQueryById();
		}
	},

	methods: {
		getInputValue(result) {
			return result.filter(item => item !== null).join(this.delimiter);
		},
		renderResult(arr, list = false) {
			const fieldsArray = this.indexFields.split(' ').map(field => field.trim());
			const valuesArray = fieldsArray.map(field => arr[field]);
			if (list) {
				return this.getInputValue(valuesArray);
			} else {
				this.inputValue = this.getInputValue(valuesArray);
			}
		},
		focusInput() {
			if (this.arrayValues.length) {
				this._handleOpenDropdown();
			}
		},
		_handleOpenDropdown() {
			this.statusOpenForm = true;
			this.bodyElem.addEventListener('click', this._handleToggleDropdown);
		},
		_handleCloseDropdown() {
			this.statusOpenForm = false;
			this.bodyElem.removeEventListener('click', this._handleToggleDropdown, false);
		},
		_handleToggleDropdown(e) {
			if (e.target.parentElement !== this.$refs.dropdownElement && e.target !== this.$refs.search) {
				this._handleCloseDropdown();
			}
		},
		sendQuery() {
			this.statusLoader = true;
			const suggesterName = this.c_ctrlParams.selectSuggesterName ? this.c_ctrlParams.selectSuggesterName : 'all-station';

				axios
					.get(`${this.baseUrl}/suggests/${suggesterName}/?namePart=${encodeURIComponent(this.inputValue)}${this.constQuery}`)
				.then((response) => {
					this.arrayValues.length = 0;
					this.arrayValues.push(...response.data.data);
					this._handleOpenDropdown();
					this.statusLoader = false;
				})
				.catch((e) => {
					console.log(e.response);
				});
		},
		sendQueryById() {
			const id = this.value && typeof this.value === 'object' ? this.value.id : this.value;

			if (id === null || typeof id === 'undefined' || id === '') {
				return;
			}

			axios
				.get(
					`${this.baseUrl}/suggests/${this.c_ctrlParams.selectSuggesterName}/?id=${encodeURIComponent(id)}${this.constQuery}`,
				)
				.then((response) => {
					this.renderResult(response.data.data[0].node, false);
					this.statusSendQuery = false;
				})
				.catch((e) => {
					console.log(e.response);
				});
		},
		select(arr) {
			const id = arr.id;
			const name = arr.name;
			this.statusSendQuery = false;

			this.renderResult(arr);

			this.$emit('update:value', id);
			this.mixin_inputEvent({
				ctrlCode: this.$props.field_meta.ctrlCode,
				dbcolname: this.$props.field_meta.dbcolname,
				evtType: 'onSelect',
				fullValue: {
					id: id,
					name: name
				},
			});
			this._handleCloseDropdown();
		},
	},
};
</script>

<style lang="css">
.lm-dropdown-menu--item {
	display: block;
}
.w-100 {
	width: 100%;
}

.lm-dropdown-wrap {
	position: relative;
}

.dropdown_query .lm-dropdown-menu {
	display: none;
	position: absolute;
	z-index: 10;
	background: #fff;
	width: 100%;
}

.dropdown_query .lm-dropdown-menu ul {
	padding: 0;
	list-style: none;
	overflow: auto;

	width: 100%;
	cursor: pointer;
	background-color: #fff;
	border: 1px solid #cbd0d8;
	border-radius: 0 0 4px 4px;
	box-shadow: 0 4px 16px 0 rgba(40, 42, 54, 0.16);
}

.dropdown_query .lm-dropdown-menu li {
	width: 100%;
	color: #282a36;
	display: block;
	font-size: 14px;
	overflow: hidden;
	padding: 4px 14px;
	white-space: nowrap;
	text-decoration: none;
	text-overflow: ellipsis;
	cursor: pointer;
}

.lm-dropdown-menu li:hover {
	color: #0063da;
	background-color: rgba(76, 159, 159, 0.15);
}

.lm-dropdown-wrap .active .lm-dropdown-menu {
	display: block;
}

.dropdown_query .spin-lg:after {
	font-size: 1em;
}

.dropdown_query .spin-lg {
	padding: 0;
}

.dropdown_query .spin-position {
	top: 4px;
	right: 14px;
	width: 10px;
	height: 6px;
	display: block;
	cursor: pointer;
	position: absolute;
}

.dropdown_query .form-control {
	font-weight: 500;
}

.dropdown_query .lm-dropdown-menu--item:last-child .delimiter {
	display: none;
}
</style>
